import { useEffect } from 'react';
import { useUIStore } from '@/state/uiStore';

/** Mounts the theme class on <html> so CSS variables apply globally.
 *  Re-runs only when theme changes; not on every render. */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove('theme-light', 'theme-dark');
    html.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
  }, [theme]);

  return <>{children}</>;
}
